// ReportsPage — tab shell for the Reports section.
//
// Tab order matches legacy reports.php (Reminders + Queue) plus the new
// Activity Logs and Browse Reports surfaces:
//   - "Automated Reminders" (default)
//   - "Message Queue"
//   - "Activity Logs"
//   - "Browse Reports"

import { useState } from 'react';
import { PageHeader } from '../../../components/ui/PageHeader/PageHeader';
import { ActivityLogsTab } from './components/ActivityLogsTab';
import { BrowseReportsTab } from './components/BrowseReportsTab';
import { RemindersTab } from './components/RemindersTab';
import { MessageQueueTab } from './tabs/MessageQueueTab';
import styles from './ReportsPage.module.css';

type Tab = 'reminders' | 'queue' | 'activity' | 'browse';

export function ReportsPage() {
  const [tab, setTab] = useState<Tab>('reminders');

  return (
    <div className={styles.page}>
      <PageHeader
        title="Reports"
        subtitle="Operational insights and activity logs"
      />

      <div role="tablist" className={styles.tabs}>
        <button
          role="tab"
          id="reports-tab-reminders"
          aria-selected={tab === 'reminders'}
          aria-controls="reports-panel-reminders"
          onClick={() => setTab('reminders')}
          className={tab === 'reminders' ? styles.active : styles.tab}
        >
          Automated Reminders
        </button>
        <button
          role="tab"
          id="reports-tab-queue"
          aria-selected={tab === 'queue'}
          aria-controls="reports-panel-queue"
          onClick={() => setTab('queue')}
          className={tab === 'queue' ? styles.active : styles.tab}
        >
          Message Queue
        </button>
        <button
          role="tab"
          id="reports-tab-activity"
          aria-selected={tab === 'activity'}
          aria-controls="reports-panel-activity"
          onClick={() => setTab('activity')}
          className={tab === 'activity' ? styles.active : styles.tab}
        >
          Activity Logs
        </button>
        <button
          role="tab"
          id="reports-tab-browse"
          aria-selected={tab === 'browse'}
          aria-controls="reports-panel-browse"
          onClick={() => setTab('browse')}
          className={tab === 'browse' ? styles.active : styles.tab}
        >
          Browse Reports
        </button>
      </div>

      <div className={styles.body}>
        {tab === 'reminders' && (
          <div
            role="tabpanel"
            id="reports-panel-reminders"
            aria-labelledby="reports-tab-reminders"
          >
            <RemindersTab />
          </div>
        )}
        {tab === 'queue' && (
          <div
            role="tabpanel"
            id="reports-panel-queue"
            aria-labelledby="reports-tab-queue"
          >
            <MessageQueueTab />
          </div>
        )}
        {tab === 'activity' && (
          <div
            role="tabpanel"
            id="reports-panel-activity"
            aria-labelledby="reports-tab-activity"
          >
            <ActivityLogsTab />
          </div>
        )}
        {tab === 'browse' && (
          <div
            role="tabpanel"
            id="reports-panel-browse"
            aria-labelledby="reports-tab-browse"
          >
            <BrowseReportsTab />
          </div>
        )}
      </div>
    </div>
  );
}
